import { useTheme } from './ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const CARD_ROOT_CLASS = 'interactive-card';
const FOCUS_RING_VAR = '--ic-focus-ring';
const focusRingRule = `.${CARD_ROOT_CLASS} :focus-visible { outline: 2px solid var(${FOCUS_RING_VAR}); outline-offset: -2px; }`;
export const useFocusRingVars = () => {
  const theme = useTheme();
  return {
    [FOCUS_RING_VAR]: theme.colors.focus
  };
};

// Render inside the card root so focus rings work in shadow DOM hosts. Injecting
// into document.head is a no-op there because the rule never reaches the shadow tree.
export const FocusRingStyles = () => /*#__PURE__*/_jsx("style", {
  children: focusRingRule
});